module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    staticClass: "learning-tutorial",
    attrs: {
      "id": _vm.id,
      "no-close-on-backdrop": "",
      "no-close-on-esc": "",
      "centered": "",
      "hide-header": "",
      "hide-footer": ""
    }
  }, [_vm._t("default", [_c('div', {
    staticClass: "carousel-caption-container"
  }, [_c('button', {
    ref: "prevIcon",
    staticClass: "prev-icon",
    attrs: {
      "type": "button",
      "disabled": _vm.slide === 0
    },
    on: {
      "click": function($event) {
        return _vm.prevSlide()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic-right-arrow-copy.svg"
    }
  })]), _vm._v(" "), _c('button', {
    ref: "nextIcon",
    staticClass: "next-icon",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextSlide()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic-right-arrow.svg"
    }
  })])]), _vm._v(" "), _c('b-carousel', {
    ref: "carousel",
    attrs: {
      "id": "carousel",
      "navigationNextLabel": "NEXT",
      "background": "#ababab",
      "interval": 0,
      "img-width": "1024",
      "img-height": "1024"
    },
    model: {
      value: (_vm.slide),
      callback: function($$v) {
        _vm.slide = $$v
      },
      expression: "slide"
    }
  }, [_c('b-carousel-slide', {
    attrs: {
      "img-src": "/static/images/bg-sam-info-modal.png"
    }
  }, [_c('div', [_c('div', {
    staticClass: "learning-tutorial-title"
  }, [_vm._v(_vm._s(_vm.$t('tutorial.step_1.title')))]), _vm._v(" "), _c('div', {
    staticClass: "learning-tutorial-description"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('tutorial.step_1.greeting')) + " " + _vm._s(_vm.isParentUser ? _vm.$t('common.parent') : ("" + _vm.userName + (_vm.$t('common.student')) + "!"))), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tutorial.step_1.description'))
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "learning-tutorial-icon",
    attrs: {
      "src": "/static/images/img-intro-01.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    staticClass: "next-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextSlide()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.next")))])])])]), _vm._v(" "), (!_vm.isParentUser) ? _c('b-carousel-slide', {
    attrs: {
      "img-src": "/static/images/bg-sam-info-modal.png"
    }
  }, [_c('div', {
    staticClass: "learning-tutorial-title"
  }, [_vm._v(_vm._s(_vm.$t("tutorial.step_2.title")))]), _vm._v(" "), _c('div', {
    staticClass: "learning-tutorial-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tutorial.step_2.description'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "learning-tutorial-setting row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "school-label"
  }, [_vm._v(_vm._s(_vm.$t('common.school_info')))]), _vm._v(" "), _c('div', {
    staticClass: "school-value"
  }, [_vm._v(_vm._s(_vm.userSchool || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "school-label"
  }, [_vm._v(_vm._s(_vm.$t('common.grade_info')))]), _vm._v(" "), _c('div', {
    staticClass: "school-value"
  }, [_vm._v(_vm._s(_vm.userGrade || '-'))])])]), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    staticClass: "setting-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openClassting()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('tutorial.step_2.update_school')))]), _vm._v(" "), _c('button', {
    ref: "nextButton",
    staticClass: "next-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextSlide()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.next')))])])]) : _vm._e(), _vm._v(" "), _c('b-carousel-slide', {
    attrs: {
      "img-src": "/static/images/bg-sam-info-modal.png"
    }
  }, [_c('div', {
    staticClass: "learning-tutorial-title"
  }, [_vm._v(_vm._s(_vm.$t('tutorial.step_3.title')))]), _vm._v(" "), _c('div', {
    staticClass: "learning-tutorial-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tutorial.step_3.description'))
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "learning-tutorial-icon",
    attrs: {
      "src": "/static/images/img-intro-02.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    staticClass: "next-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextSlide()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.next')))])])]), _vm._v(" "), _c('b-carousel-slide', {
    attrs: {
      "img-src": "/static/images/bg-sam-info-modal.png"
    }
  }, [_c('div', {
    staticClass: "learning-tutorial-title"
  }, [_vm._v(_vm._s(_vm.$t('tutorial.step_4.title')))]), _vm._v(" "), _c('div', {
    staticClass: "learning-tutorial-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tutorial.step_4.description'))
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "learning-tutorial-icon",
    attrs: {
      "src": "/static/images/img-intro-03.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    staticClass: "next-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextSlide()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.next')))])])]), _vm._v(" "), _c('b-carousel-slide', {
    attrs: {
      "img-src": "/static/images/bg-sam-info-modal.png"
    }
  }, [_c('div', {
    staticClass: "learning-tutorial-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('tutorial.step_5.title', {
    user: _vm.isParentUser ? _vm.$t('common.child') : _vm.$t('common.me')
  })) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "learning-tutorial-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tutorial.step_5.description'))
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "learning-tutorial-icon",
    attrs: {
      "src": "/static/images/img-intro-04.png",
      "alt": "icon"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    staticClass: "next-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.modalHide()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('tutorial.step_5.end_tutorial')))])])])], 1)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bac4c56","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/cat-main/components/CatTutorial.vue
// module id = 1557
// module chunks = 1